<template>
	<div class="site-section interior">
    <section class="hero is-medium is-black is-vcentered">
      <div class="columns is-tablet">
        <div class="column is-one-third is-one-quarter-tablet is-full-mobile">
          <img src="../../assets/hero-daddy-academy.png">
        </div>
        <div class="column">
          <div class="hero-body">
            <h1 class="is-size-1 lucky-title">
              Security and Safety
            </h1>
            <div class="intro">NFDaddys are dedicated to safety in Web3!</div>
          </div>
        </div>
      </div>
    </section>
    <section class="body-content">
      <p>Learning the tech will keep you safe.  </p>
      <p>We implement best practices we continue to evolve as the arena changes and the rules change.</p>
      <p>Here is one safety tip to consider for your Discord Adventures!</p>
      <div>
        <iframe
          class="has-ratio"
          width="640"
          height="360"
          src="https://www.youtube.com/embed/FiCdMRCbKR4"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </section>
	</div>
</template>
<script>
/* eslint-disable no-console */
export default {
  name: "SecurityAndSafety",
  methods: {

  },
};
/* eslint-enable no-console */
</script>
<style scoped>


</style>